export const colorsBackground = [
  '#999999',
  '#323232',
  '#A28A68',
  '#4D6390',
  '#8C5051',
  '#ADB361',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
